/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponsePeopleProfilePhotoUrlResponseData } from './genericApiResponsePeopleProfilePhotoUrlResponseData';
import type { GenericApiResponsePeopleProfilePhotoUrlResponseMessage } from './genericApiResponsePeopleProfilePhotoUrlResponseMessage';
import type { GenericApiResponsePeopleProfilePhotoUrlResponsePagination } from './genericApiResponsePeopleProfilePhotoUrlResponsePagination';
import type { GenericApiResponsePeopleProfilePhotoUrlResponseError } from './genericApiResponsePeopleProfilePhotoUrlResponseError';

export interface GenericApiResponsePeopleProfilePhotoUrlResponse {
  data?: GenericApiResponsePeopleProfilePhotoUrlResponseData;
  message?: GenericApiResponsePeopleProfilePhotoUrlResponseMessage;
  pagination?: GenericApiResponsePeopleProfilePhotoUrlResponsePagination;
  error?: GenericApiResponsePeopleProfilePhotoUrlResponseError;
  statusCode?: number;
}
